import { merge } from 'lodash';
import getEms from './getEms';
export default function getSpacing(styleObject, customStyleSettings) {
    const mergedStyleObject = merge({}, styleObject, customStyleSettings);
    if (!mergedStyleObject || !mergedStyleObject.spacing) {
        return {};
    }
    const paddings = mergedStyleObject.spacing.padding;
    const newPaddings = {};
    Object.keys(paddings).forEach(key => {
        const padding = paddings[key];
        // Convert paddings that are larger than 15px to rem to reduce spacing on smaller browser viewports.
        newPaddings[key] = padding <= 15 ? padding : `${getEms(padding)}rem`;
    });
    return newPaddings;
}
